// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__ihKA6","summary":"Footer_summary__tX97s","actions":"Footer_actions__6PIov"};